import { IPublicClientApplication } from '@azure/msal-browser';
import { apiClient } from '@/api/apiClient';
import { apiService } from '@/api/apiService';
import { clearUserInfoGlobal } from '@/api/config';
import { buildLoginRequest } from './msalConfig';

export const SIGNED_OUT_STORAGE_KEY = 'chatbot.signedOut';

function clearLocalUserState(): void {
    apiService.clearCache();
    clearUserInfoGlobal();
}

export async function switchAccount(
    instance: IPublicClientApplication,
    clientId: string,
): Promise<void> {
    clearLocalUserState();
    await instance.loginRedirect({
        ...buildLoginRequest(clientId),
        prompt: 'select_account',
    });
}

export async function signOut(instance: IPublicClientApplication): Promise<void> {
    sessionStorage.setItem(SIGNED_OUT_STORAGE_KEY, '1');
    try {
        await apiClient.post('/auth/logout', {});
    } catch (error) {
        console.warn('Unable to clear the server-side session cache during sign-out.', error);
    }
    clearLocalUserState();
    await instance.logoutRedirect({
        account: instance.getActiveAccount() ?? undefined,
    });
}

export async function signIn(
    instance: IPublicClientApplication,
    clientId: string,
): Promise<void> {
    sessionStorage.removeItem(SIGNED_OUT_STORAGE_KEY);
    await instance.loginRedirect({
        ...buildLoginRequest(clientId),
        prompt: 'select_account',
    });
}
